import styled, { css } from 'styled-components';
import { AllieText } from '../../../../../components';
import { getCssVar } from '../../../../../common/utils';

export const ContainerRateEstimated = styled.div<{ backgroundColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) => backgroundColor ?? ''} !important;
  ${({ backgroundColor }) =>
    backgroundColor
      ? css`
          border: 2px solid ${backgroundColor};
        `
      : ''}

  & div {
    background: transparent !important;
  }
`;

export const StyledRateProgress = styled(AllieText)`
  @media (min-width: ${() => getCssVar('--breakpoint-desktop-lg', '1600px')}) {
    font-size: 18px !important;
    line-height: 25px !important;
  }

  @media (min-width: ${() => getCssVar('--breakpoint-desktop-xl', '1920px')}) {
    font-size: 20px !important;
    line-height: 28px !important;
  }
`;

export const StyledEstimated = styled(AllieText)`
  @media (min-width: ${() => getCssVar('--breakpoint-desktop-lg', '1600px')}) {
    font-size: 14px !important;
    line-height: 20px !important;
  }

  @media (min-width: ${() => getCssVar('--breakpoint-desktop-xl', '1920px')}) {
    font-size: 16px !important;
    line-height: 22px !important;
  }
`;
